// Business lines served by the phone server (v1.3).
export const LINE_IDS = ["reco_pneus", "ecrin_du_sud"];
export const LINE_LABELS = { reco_pneus: "Reco Pneus", ecrin_du_sud: "L'Écrin du Sud" };
export const LINE_NATIONAL = { reco_pneus: "04 23 34 06 34", ecrin_du_sud: "04 23 34 01 65" };

export const lineLabel = (line) => LINE_LABELS[line] || null;

// localStorage: last line this member called from (default for "Appeler").
export const lastLineKey = (memberId) => `sc_last_line_${memberId || "anon"}`;
export const getLastLine = (memberId) => {
  const v = localStorage.getItem(lastLineKey(memberId));
  return LINE_LABELS[v] ? v : null;
};
export const setLastLine = (memberId, line) => {
  if (LINE_LABELS[line]) localStorage.setItem(lastLineKey(memberId), line);
};
